<template>
  <div>
    <div class="qs-answer-variant" v-for="(answer, index) in answers" :key="index">
      <div class="main d-flex justify-content-center">
        <div
          :class="{ 'checked': answer.checked }"
          @click="check(index, answer.checked)"
          class="radio-btn d-flex justify-content-center align-items-center"
        >
          <span class="icon-selected"></span>
        </div>
        <input
          type="text"
          class="answer-input"
          @input="$emit('input', { index, value: $event.target.value })"
          v-model="answer.text"
          :placeholder="placeHolder"
          :disabled="type === 'trueFalse'"
        >
        <div v-if="attach" class="attach-btn d-flex justify-content-center align-items-center">
          <span class="icon-attachment-clip mr-1"></span>
          <span>Attach</span>
        </div>
      </div>

      <div class="trash d-flex mt-1">
        <button class="ml-auto">
          <span class="icon-garbage"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Answer",
  data() {
    return {
      answers: []
    };
  },
  props: {
    attach: {
      type: Boolean,
      default: true
    },
    placeHolder: {
      type: String,
      default: "Type the answer..."
    },
    type: {
      type: String
    }
  },
  methods: {
    computeLength() {
      if (this.type === "writeAnswer") {
        this.answers.push({ checked: true });
      } else if (this.type === "trueFalse") {
        for (let i = 0; i < 2; i++) {
          this.answers.push({
            checked: i === 0 ? true : false,
            text: i === 0 ? "True" : "False"
          });
        }
      } else {
        for (let i = 0; i < 4; i++) {
          this.answers.push({ checked: i === 0 ? true : false });
        }
      }
    },
    check(index, value) {
      if (this.type !== "writeAnswer") {
        for (const answer of this.answers) {
          if (answer.checked) answer.checked = !answer.checked;
        }

        this.answers[index].checked = !value;
      }

      this.$emit("checked", this.answers[index]);
    }
  },
  mounted() {
    this.computeLength();

    this.$emit("mounted", this.answers);
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.qs-answer-variant .main {
  background-color: #f8f8f9;
  position: relative;
  min-height: 60px;
  border-radius: $borderRadius;

  .radio-btn {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 10px;
    background-color: $greyLight;
    height: 100%;
    border-radius: $borderRadius 0 0 $borderRadius;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .radio-btn.checked {
    background-color: $green;
  }

  .radio-btn:hover {
    background-color: #00adb38f;
  }

  .radio-btn:focus,
  .radio-btn:active {
    background-color: $green;
  }

  .answer-input {
    text-align: center;
    padding: 0.4rem 0.9rem;
    color: $placeholderColor;
    border-radius: $borderRadius;
    border: none;
    outline: none;
    font-size: 20px;
    width: 85%;
    height: 100%;
    min-height: 60px;
    background-color: #f8f8f9;
    overflow-y: hidden;
  }

  .answer-input::placeholder {
    color: $greyLight;
  }

  .attach-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 4px 8px;
    background-color: $violet;
    border-radius: 0 0 $borderRadius 0;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    .icon-attachment-clip {
      font-size: 1.2em;
    }
  }
}

.qs-answer-variant .trash {
  button {
    background-color: $red;
    outline: none;
    border: none;
    border-radius: $borderRadius;
    padding: 5px 10px;
    transition: all 0.3s ease;
  }
}
</style>
